<template>
  <div class="my-page-shout-out">
    <p class="my-page-shout-out__text">
      <span v-html="$t('afterSale.afterSaleAvalibleMessage')" />
    </p>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { useI18n } from 'vue-i18n'

  export default defineComponent({
    name: 'MyPageShoutOut',
  })
</script>

<style lang="scss">
  .my-page-shout-out {
    max-width: 700px;
    &__text {
      @include body-medium;
      text-align: left;
      background-color: $clr-tertiary-200;
      color: $clr-text;
      border-radius: $border-radius;
      padding: 1rem 1rem;
      margin-top: 0;
      margin-bottom: 0;

      a {
        color: $clr-primary;
        text-decoration: underline;
      }
    }
  }
</style>
